module.exports = {
	"description": "",
	"methods": [],
	"props": {
		"children": {
			"flowType": {
				"name": "MnrlReactNode"
			},
			"required": false,
			"description": "Components to which the theme will be applied"
		},
		"theme": {
			"flowType": {
				"name": "Object"
			},
			"required": false,
			"description": "A shallow object of theme variables and their values",
			"defaultValue": {
				"value": "mineralTheme",
				"computed": true
			}
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-docgen-loader!./src/ThemeProvider/ThemeProvider.js
// module id = 1644
// module chunks = 0